export const ENV_STORAGE_KEY = 'admin-ui.selectedEnvironment';

export const ENV_KEYS = {
  DEV: 'DEV',
  UAT: 'UAT',
  PROD: 'PROD',
};

export const DEFAULT_ENV_KEY = ENV_KEYS.UAT;

const buildEnvironment = (suffix) => ({
  botApi: process.env[`REACT_APP_BOT_API_${suffix}`],
  conversationApi: process.env[`REACT_APP_CONVERSATION_API_${suffix}`],
  agendaApi: process.env[`REACT_APP_AGENDA_API_${suffix}`],
  dashboard: process.env[`REACT_APP_DASHBOARD_${suffix}`],
  chat: process.env[`REACT_APP_CHAT_${suffix}`],
  listBots: process.env[`REACT_APP_BOT_API_${suffix}`],
  apiKey: process.env[`REACT_APP_API_KEY_${suffix}`],
});

export const ENVIRONMENTS = {
  [ENV_KEYS.DEV]: buildEnvironment('DEV'),
  [ENV_KEYS.UAT]: buildEnvironment('UAT'),
  [ENV_KEYS.PROD]: buildEnvironment('PROD'),
};

export const environmentOptions = [
  { label: 'Dev', key: ENV_KEYS.DEV },
  { label: 'UAT', key: ENV_KEYS.UAT },
  { label: 'Prod', key: ENV_KEYS.PROD },
];

export const isValidEnvKey = (key) => Boolean(ENVIRONMENTS[key]);

export const getEnvironmentByKey = (key) =>
  ENVIRONMENTS[isValidEnvKey(key) ? key : DEFAULT_ENV_KEY];

export const isProdEnvironmentKey = (key) => key === ENV_KEYS.PROD;

export const readStoredEnvKey = () => {
  try {
    const stored = window.localStorage.getItem(ENV_STORAGE_KEY);
    return isValidEnvKey(stored) ? stored : DEFAULT_ENV_KEY;
  } catch {
    return DEFAULT_ENV_KEY;
  }
};

export const persistEnvKey = (key) => {
  if (!isValidEnvKey(key)) {
    return;
  }

  try {
    window.localStorage.setItem(ENV_STORAGE_KEY, key);
  } catch {
    // Ignore storage failures (private mode, quota, etc.)
  }
};
